import { Step, StepLabel, Stepper } from '@mui/material';

// Step numbers (1-based):
// 1 = Master Data
// 2 = Include Timetable?
// 3 = Academic Year (only when includeTimetable=true)
// 4 = Timetable Format
// 5 = Upload Timetable
// 6 = Confirm & Import
const STEPS = [
  'Master Data',
  'Include Timetable?',
  'Academic Year',
  'Timetable Format',
  'Upload Timetable',
  'Confirm & Import',
];

interface WizardStepIndicatorProps {
  currentStep: number; // 1-based
  includeTimetable: boolean | null;
}

export function WizardStepIndicator({ currentStep, includeTimetable }: WizardStepIndicatorProps) {
  // When not including timetable, hide steps 3-5
  const steps = includeTimetable === false
    ? [STEPS[0], STEPS[1], STEPS[5]]
    : STEPS;

  // Map currentStep to display index
  let activeIndex = currentStep - 1;
  if (includeTimetable === false && currentStep === 6) activeIndex = 2;

  return (
    <Stepper activeStep={activeIndex} alternativeLabel sx={{ py: 3 }}>
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
